import theme from 'config/theme';

export default {
  wrapper: {
    border: `1px solid ${theme?.palette?.secondary?.main}`,
    padding: '16px',
    borderRadius: '8px',
    width: '414px',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  title: {
    width: '100%',
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: '23px',
    paddingBottom: '8px',
    textAlign: 'center',
  },
  addIcon: {
    cursor: 'pointer',
  },
  container: {
    border: 'none',
    padding: 0,
  },
};

export const modalStyles = {
  row: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    marginBottom: '16px',
    gap: '16px',
  },
};
